import { render, staticRenderFns } from "./timestamp.vue?vue&type=template&id=6e05d234"
import script from "./timestamp.vue?vue&type=script&lang=js"
export * from "./timestamp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports